import SlideToggle from 'react-slide-toggle';
import {useSearchParams} from 'react-router-dom';
import {useEffect, useMemo, useState} from 'react';
import StickyBox from 'react-sticky-box';
import Tree from 'rc-tree';

import {connect} from "react-redux";
import {getProductList, setCategoryFilter, setProductPage, setProductPriceFilter} from "../../../../store/products/actions";
import {updateSearchParams} from "../../../../utils";
import useTranslation from "../../../../utils/hooks/useTranslation";

const TreeNode = ( props ) => {
    return (
        <b>
            { props.name }
        </b>
    )
}

function ShopSidebarOne ({display, right, category, setCategoryFilter, selectedCategory, setProductPage, minPrice, maxPrice, setProductPriceFilter} ) {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const {list, loading, error} = category;
    const selectedChildrenCategory = getChildrenOfChildrenCategoryParentId(selectedCategory);
    const selectedParentCategory = getChildrenCategoryParentId( selectedChildrenCategory ? selectedChildrenCategory : selectedCategory);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [minPriceInput, setMinPriceInput] = useState(minPrice ?? '');
    const [maxPriceInput, setMaxPriceInput] = useState(maxPrice ?? '');

    useEffect(() => {
        setMinPriceInput(minPrice ?? '');
        setMaxPriceInput(maxPrice ?? '');
    }, [minPrice, maxPrice]);
    const categories = useMemo( () => {
        let cats = list ? list : [];
        let result = [];
        result = cats.reduce( ( acc, cur ) => {
            let newNode = {
                key: cur.id,
                title: <b>{cur.name}</b>,
                children: fixChildrenFormat(cur.children)
            };

            acc.push( newNode );

            return acc;
        }, [] );

        return result;
    }, [ list, fixChildrenFormat ] );

    useEffect( () => {
        return () => {
            closeSidebar();
        }
    }, [] )

    useEffect(() => {
        setExpandedKeys([selectedChildrenCategory, selectedParentCategory, selectedCategory]);
    }, [list, selectedCategory, selectedChildrenCategory, selectedParentCategory]);

    useEffect(() => {
        let treeNodes = document.querySelectorAll('.rc-tree-treenode');
        let isChildren = false;
        treeNodes = [...treeNodes].filter((node, index) => {
            if(node.classList.contains('rc-tree-treenode-switcher-open')) {
                isChildren = true;
            }

            if(isChildren) {
                node.classList.add("border-0");
            }

            if(node.classList.contains('rc-tree-treenode-leaf-last') && index < (treeNodes.length - 1)) {
                isChildren = false;
            }

            return node.classList.contains('rc-tree-treenode-switcher-close')
        })
    }, [expandedKeys])

    function fixChildrenFormat(children) {
        let childNodes = [];
        children?.forEach((child) => {
            childNodes.push({
                key: child.id,
                title: <b>{child.name}</b>,
                children: fixChildrenFormat(child.children)
            });
        })

        return childNodes;
    }

    function filterByCategory ( selected ) {
        let categoryId = selected[0];

        if(!categoryId) {
            return;
        }

        setCategoryFilter(categoryId);

        let params = {
            category: categoryId,
        };

        setProductPage(1);

        params = updateSearchParams(searchParams, params);
        setSearchParams(params);
    }

    function clearCategory() {
        setCategoryFilter(null);
        setProductPage(1);
        const params = {};
        searchParams.forEach((value, key) => {
            if (key !== 'category') params[key] = value;
        });
        params.page = 1;
        setSearchParams(params);
    }

    function applyPriceFilter(e) {
        e?.preventDefault?.();

        const minRaw = minPriceInput === '' || minPriceInput === null ? null : Number(minPriceInput);
        const maxRaw = maxPriceInput === '' || maxPriceInput === null ? null : Number(maxPriceInput);

        let min = Number.isFinite(minRaw) && minRaw >= 0 ? minRaw : null;
        let max = Number.isFinite(maxRaw) && maxRaw >= 0 ? maxRaw : null;

        if (min !== null && max !== null && min > max) {
            [min, max] = [max, min];
        }

        setProductPriceFilter({ min, max });
        setProductPage(1);

        const baseParams = {};
        searchParams.forEach((value, key) => {
            if (key !== 'min_price' && key !== 'max_price') baseParams[key] = value;
        });
        if (min !== null) baseParams.min_price = String(min);
        if (max !== null) baseParams.max_price = String(max);
        baseParams.page = 1;
        setSearchParams(baseParams);
    }

    function clearPriceFilter() {
        setProductPriceFilter({ min: null, max: null });
        setMinPriceInput('');
        setMaxPriceInput('');
        setProductPage(1);

        const params = {};
        searchParams.forEach((value, key) => {
            if (key !== 'min_price' && key !== 'max_price') params[key] = value;
        });
        params.page = 1;
        setSearchParams(params);
    }

    const hasActivePriceFilter = minPrice !== null || maxPrice !== null;

    function findCategoryName(nodes, id) {
        if(!nodes || id == null) return null;
        for (const n of nodes) {
            if (n.id === id) return n.name;
            const found = findCategoryName(n.children, id);
            if (found) return found;
        }
        return null;
    }

    const activeCategoryName = findCategoryName(list, selectedCategory);

    function toggleCategory( categoryId ) {
        expandedKeys.includes(categoryId) ? setExpandedKeys(expandedKeys.filter(i => i !== categoryId)) : setExpandedKeys([ ...expandedKeys, categoryId ]);
    }

    function getChildrenCategoryParentId(categoryId) {
        return list?.filter(categories => categories.children.some(cat => cat.id === categoryId))[0]?.id;
    }

    function getChildrenOfChildrenCategoryParentId(categoryId) {
        return list?.flatMap(categories => {
            let res = categories.children.filter(cat => cat.children.some(childCat => childCat.id === categoryId))[0]?.id;
            return res ? res : [];
        })[0];
    }

    function closeSidebar () {
        document.querySelector( 'body' ).classList.contains( 'sidebar-opened' ) && document.querySelector( 'body' ).classList.remove( 'sidebar-opened' );
    }

    if ( error ) {
        return <div>{ error.message }</div>
    }

    return (
        <>
            <div className="sidebar-overlay" onClick={ closeSidebar }></div>
            <aside className={ `sidebar-shop col-lg-3  mobile-sidebar skeleton-body skel-shop-products ${ !loading ? 'loaded' : '' } ${ display === 'none' ? 'd-lg-none' : '' } ${ right ? '' : 'order-lg-first' }` }>
                <StickyBox className="sidebar-wrapper" offsetTop={ 70 }>
                    {/*<div className="widget widget-price">*/}
                    {/*    <h3 className="widget-title">*/}
                    {/*        <a>{t("label.price") || "Price"}</a>*/}
                    {/*        {hasActivePriceFilter ? (*/}
                    {/*            <button type="button" className="sidebar-clear" onClick={clearPriceFilter}>*/}
                    {/*                {t("label.clear") || "Clear"}*/}
                    {/*            </button>*/}
                    {/*        ) : null}*/}
                    {/*    </h3>*/}
                    {/*    <div className="widget-body">*/}
                    {/*        {hasActivePriceFilter ? (*/}
                    {/*            <span className="sidebar-active-chip mb-2">*/}
                    {/*                {minPrice !== null ? minPrice : '…'} – {maxPrice !== null ? maxPrice : '…'}*/}
                    {/*                <button type="button" onClick={clearPriceFilter} aria-label="Clear">&times;</button>*/}
                    {/*            </span>*/}
                    {/*        ) : null}*/}
                    {/*        <form className="price-range-form" onSubmit={applyPriceFilter}>*/}
                    {/*            <div className="price-range-inputs">*/}
                    {/*                <input*/}
                    {/*                    type="number"*/}
                    {/*                    min="0"*/}
                    {/*                    inputMode="numeric"*/}
                    {/*                    className="form-control price-input"*/}
                    {/*                    placeholder={t("label.min") || "Min"}*/}
                    {/*                    value={minPriceInput}*/}
                    {/*                    onChange={(e) => setMinPriceInput(e.target.value)}*/}
                    {/*                />*/}
                    {/*                <span className="price-range-dash">–</span>*/}
                    {/*                <input*/}
                    {/*                    type="number"*/}
                    {/*                    min="0"*/}
                    {/*                    inputMode="numeric"*/}
                    {/*                    className="form-control price-input"*/}
                    {/*                    placeholder={t("label.max") || "Max"}*/}
                    {/*                    value={maxPriceInput}*/}
                    {/*                    onChange={(e) => setMaxPriceInput(e.target.value)}*/}
                    {/*                />*/}
                    {/*            </div>*/}
                    {/*            <button type="submit" className="btn btn-dark btn-block price-apply-btn">*/}
                    {/*                {t("label.apply") || "Apply"}*/}
                    {/*            </button>*/}
                    {/*        </form>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className="widget">
                        <SlideToggle>
                            { ( { setCollapsibleElement} ) => (
                                <>
                                    <h3 className="widget-title">
                                        <a>{t("label.categories")}</a>
                                        {selectedCategory ? (
                                            <button type="button" className="sidebar-clear" onClick={clearCategory}>
                                                {t("label.clear") || "Clear"}
                                            </button>
                                        ) : null}
                                    </h3>
                                    <div className="overflow-hidden" ref={ setCollapsibleElement }>
                                        <div className="widget-body">
                                            {activeCategoryName ? (
                                                <span className="sidebar-active-chip m-2">
                                                    {activeCategoryName}
                                                    <button type="button" onClick={clearCategory} aria-label="Clear">&times;</button>
                                                </span>
                                            ) : null}
                                            <Tree
                                                className={`no-icon cat-list border-0`}
                                                selectable={ true }
                                                showIcon={ false }
                                                expandedKeys={ expandedKeys }
                                                switcherIcon={ ( props ) => {
                                                    return ( !props.isLeaf ?
                                                        <span className="toggle" onClick={() => toggleCategory(props.eventKey)}></span>
                                                        : ''
                                                    )
                                                } }
                                                selectedKeys={ [ selectedCategory ] }
                                                treeData={ categories }
                                                onSelect={ filterByCategory }
                                            />
                                        </div>
                                    </div>
                                </>
                            ) }
                        </SlideToggle>
                    </div>
                </StickyBox>
            </aside>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        category: state.categories,
        selectedCategory: state.products.selected_category,
        minPrice: state.products.min_price,
        maxPrice: state.products.max_price,
    }
}

const mapDispatchToProps = {setCategoryFilter, getProductList, setProductPage, setProductPriceFilter}

export default connect( mapStateToProps, mapDispatchToProps )( ShopSidebarOne );
